"use client";
import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import convertHTMLtoJSX from "@/next-src/utils/convertHTMLtoJSX";
import Benefit from "./benefit/Benefit";
import useWindowDimensions from "@/next-src/hooks/useWindowDimensions";

import comCSS from "./Benefits.module.scss";

const Benefits = ({ className = "", data = {} }) => {
  const { width: windowWidth } = useWindowDimensions();

  const { preTitleMobile, titleMobile, textMobile, bgColorMobile, benefits } =
    data || {};

  let { preTitle, title, text, bgColor } = data || {};

  if (windowWidth < 992) {
    preTitle = preTitleMobile;
    title = titleMobile;
    text = textMobile;
    bgColor = bgColorMobile;
  }
  return (
    <section
      className={cn(className, comCSS.wrapper, "section")}
      style={{
        backgroundColor: bgColor,
      }}
    >
      <div className="padding-global">
        <div className="container-large">
          <div className="padding-section-large">
            <div className="margin-bottom margin-xlarge">
              <div className="section_heading-wrapper">
                <div className="section_heading">
                  <div className="max-width-large">
                    <div className="margin-bottom margin-xsmall">
                      <div className="text-note">
                        {convertHTMLtoJSX(preTitle)}
                      </div>
                    </div>
                    <div className="margin-bottom margin-xsmall">
                      {convertHTMLtoJSX(title)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-layout-grid _4-column-grid">
              {benefits
                ?.filter((item) => !item.hide)
                ?.map((item, index) => (
                  <Benefit key={index} data={item} />
                ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

Benefits.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({
    preTitle: PropTypes.string,
    preTitleMobile: PropTypes.string,
    title: PropTypes.string,
    titleMobile: PropTypes.string,
    text: PropTypes.string,
    benefits: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        titleMobile: PropTypes.string,
        text: PropTypes.string,
        textMobile: PropTypes.string,
        image: PropTypes.shape({
          id: PropTypes.string,
          src: PropTypes.string,
          alt: PropTypes.string,
        }),
        hide: PropTypes.bool,
      })
    ),
    bgColor: PropTypes.string,
    bgColorMobile: PropTypes.string,
  }),
};

export default Benefits;
